import React from 'react';
export function MechanismShift() {
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-156">
      <div className="max-w-4xl mx-auto" data-id="element-157">
        <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 leading-tight" data-id="element-158">
          El problema nunca fue manifestar.{' '}
          <span className="text-brand-gold" data-id="element-159">
            Fue desde dónde estabas intentando hacerlo.
          </span>
        </h2>

        <div className="text-center text-sm sm:text-base text-brand-gray max-w-2xl mx-auto mb-5 space-y-1.5" data-id="element-160">
          <p data-id="element-161">
            No es falta de esfuerzo. No es falta de capacidad. No es falta de
            deseo.
          </p>
          <p className="text-brand-white" data-id="element-162">
            Tu sistema sigue funcionando desde programas viejos. Creencias.
            Miedo. Patrones. Condicionamientos.
          </p>
        </div>

        <div className="border border-brand-gold bg-brand-gold/5 rounded-lg p-5 sm:p-6 text-center" data-id="element-163">
          <p className="font-serif text-xl sm:text-2xl md:text-3xl font-semibold text-brand-gold leading-tight" data-id="element-164">
            Cuando cambia tu identidad, cambia tu realidad.
          </p>
        </div>
      </div>
    </section>;
}